import { IconTableOff } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * Removes the selected table.
 */
export default function RemoveTable({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Odstrániť tabuľku"
      icon={<IconTableOff />}
      onClick={() => editor.chain().focus().deleteTable().run()}
    />
  );
}
